
import { CollaboratorsApiRemoteService } from '../../Services/api/collaborators/collaborators-service'
import { ICollaboratorListResponse, IListCollaboratorsPayload } from '../../Services/api/collaborators/collaborators.interface'
import { ICustomerListResponse,  } from '../../Services/api/customers/customers.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListCollaboratorsUseCase
implements IFormUsecase<IListCollaboratorsPayload, ICollaboratorListResponse> {
  constructor (private readonly CollaboratorsApi: CollaboratorsApiRemoteService) {}
    

  public async handle (
    data: IListCollaboratorsPayload
  ): Promise<Result<ICollaboratorListResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CollaboratorsApi.list(data)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
